module.exports = __webpack_public_path__ + "img/login_bg.5973157f.png";